<template>
  <div class="radio" :class="{'disable':disable, 'on':!disable&&check}" @click="select">
    <div class="icon"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'radio',
  props: {
    check: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    select () {
      !this.disable && this.$emit('select')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";
.radio {
  position: relative;
  padding-left: 50px;
  line-height: 60px;
  min-height: 60px;
  color: $ucar_font_color;
  .icon {
    width: 23px;
    height: 23px;
    border: 2px solid $ucar_font_color;
    top: 14px;
    left: 0;
    border-radius: 100%;
    position: absolute;
  }
  &.on {
    color: $ucar_main_color;
    .icon {
      border-color: $ucar_main_color;
      &::after {
        position: absolute;
        content: "";
        display: block;
        width: 11px;
        height: 11px;
        border-radius: 100%;
        background-color: $ucar_main_color;
        top: 6px;
        left: 6px;
      }
    }
  }
  &.disable {
    color: $ucar_font_assist_color;
    .icon {
      border-color: $ucar_font_assist_color;
    }
  }
}
</style>
